<template>
    <div id="home-page" class="container">

        <featured-posts class="row d-none d-sm-flex" :data="featuredPosts"></featured-posts> <!-- top blocks and slider -->

        <ad :data="home_featured_230h" class="mt-3"></ad>
        <google-ad :data="ghome_featured_230h" class="mt-3"></google-ad>

        <!-- for mobile !-->
        <div class="row featured-mobile d-block d-sm-none">
            <div class="col-lg-12"> <!-- left side -->
                <post-block-group title="Legfrissebb" color="#ec0000" class="row">
                    <post-list-item v-for= "item in featured_mobile_items" v-bind:data="item" v-bind:key="item.ID"></post-list-item>
                </post-block-group>
            </div>
        </div>

        <!-- end mobile slide changes -->

        <div class="row">
            <div class="col-lg-8"> <!-- left side -->
                <post-block-group title="24 óra" color="#ec0000" class="row">
                    <post-list-item v-for= "item in recentPosts" v-bind:data="item" v-bind:key="item.ID"></post-list-item>
                </post-block-group>
                <div class="row" v-if="(home_category1_190 && home_category1_190.id) || (ghome_category1_190 && ghome_category1_190.id)">
                    <div class="col-12 pt-2">
                        <ad :data="home_category1_190" v-if="(home_category1_190 && home_category1_190.id)"></ad>
                        <google-ad :data="ghome_category1_190" v-if="(ghome_category1_190 && ghome_category1_190.id)"></google-ad>
                    </div>
                </div>
                <div class="row">
                    <post-block-group title="Magyarellenesség" color="#1e88e5" class="ml-0 p-3 p-lg-0">
                        <div class="col-lg-6 col-md-6">
                            <post-small-block :data="techItemsCover"></post-small-block>
                        </div>
                        <div class="col-lg-6 col-md-6 ml-m6 ml-xs-0 ml-sm-0 ml-md-0 pr-lg-5">
                            <div class="list-post-block">
                                <ul class="list-post">
                                    <post-list-item-small v-for="item in techItems" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </post-block-group>
                </div>
                <div class="row" v-if="(home_category2_190 && home_category2_190.id) || (ghome_category2_190 && ghome_category2_190.id)">
                    <div class="col-12 pt-2">
                        <ad :data="home_category2_190" v-if="(home_category2_190 && home_category2_190.id)"></ad>
                        <google-ad :data="ghome_category2_190" v-if="(ghome_category2_190 && ghome_category2_190.id)"></google-ad>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"> <!-- right side -->
                <div class="col-lg-12 col-md-12 most-popular-cont">
                    <widget class="most-popular mt-40" title="Legnépszerűbb">
                        <div class="row">
                            <post-small-block class="pad-right-block" color="#000" :data="mostPopularPostCover"></post-small-block>
                        </div>
                        <div class="row">
                            <div class="list-post-block pad-right-block">
                                <ul class="list-post">
                                    <post-list-item-small v-for="item in mostPopularPosts" v-bind:data="item" v-bind:key="item.ID">
                                    </post-list-item-small>
                                </ul>
                            </div>
                        </div>
                    </widget>
                    <div class="row" v-if="(home_popular_370 && home_popular_370.id) || (ghome_popular_370 && ghome_popular_370.id)">
                    <div class="col-12 pt-2 pl-lg-0">
                        <ad :data="home_popular_370" v-if="(home_popular_370 && home_popular_370.id)"></ad>
                        <google-ad :data="ghome_popular_370" v-if="(ghome_popular_370 && ghome_popular_370.id)"></google-ad>
                    </div>
                </div>
                    <widget class="w-fan-page mt-40" title="Kövessen minket">
                        <div class="fb-page col-lg-12 col-md-12 col-sm-12 pl-0"
                             data-href="https://www.facebook.com/Szekelyfold.ma/"
                             data-width="350"
                             data-hide-cover="true"
                             data-show-facepile="false"></div>
                    </widget>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-for="kw in mostUsedKeywordsPosts" v-bind:data="kw" v-bind:key="kw.keyword" class="pl-lg-0 col-lg-4 home-block-g">
                <post-block-group :title="kw.keyword" :color="kw.color">
                    <div class="row p-3 p-lg-0 ">
                        <post-small-block class="hblock" :color="kw.color" :data="kw.cover"></post-small-block>
                    </div>
                    <div class="row hblock">
                        <div class="list-post-block">
                            <ul class="list-post p-3 p-lg-0">
                                <post-list-item-small v-for="item in kw.posts.data" v-bind:data="item" v-bind:key="item.id">
                                </post-list-item-small>
                            </ul>
                        </div>
                    </div>
                </post-block-group>
            </div>
        </div>
    </div>
</template>

<script>
    import FeaturedPosts from '../post/FeaturedPosts.vue'
    import PostBlockWrapper from "../post/PostBlockWrapper";
    import PostBlockGroup from '../post/PostBlockGroup'
    import PostSmallBlock from "../post/PostSmallBlock";
    import PostListItemSmall from "../post/PostListItemSmall";
    import PostListItem from "../post/PostListItem";
    import Widget from "../addons/Widget";
    import { mapGetters, mapActions } from 'vuex'
    import Ad from '../addons/Ad'
    import GoogleAd from '../addons/GoogleAd'

    export default {
        name: 'HomePage',
        data() {
            return {
                featuredPosts: this.getFeaturedPosts,
                mostUsedKeywordsPosts: this.getMostUsedKeywordsPosts,
                recentPosts: this.getRecentPosts,
                mostPopularPostCover: this.getMostPopularPostCover,
                mostPopularPosts: this.getMostPopularPosts,
                techItemsCover: this.getTechItemsCover,
                techItems: this.getTechItems,
                blockItems: this.getBlockItems,
                slideItems: this.getSlideItems,
                banners: [],
                home_featured_230h: {},
                home_category1_190: {},
                home_category2_190: {},
                home_popular_370: {},

                gbanners: [],
                ghome_featured_230h: {},
                ghome_category1_190: {},
                ghome_category2_190: {},
                ghome_popular_370: {},
            }
        },
        computed: {
            ...mapGetters([
                'getFeaturedPosts',
                'getRecentPosts',
                'getMostPopularPostCover',
                'getMostPopularPosts',
                'getTechItems',
                'getTechItemsCover',
                'getMostUsedKeywordsPosts',
                'getSlideItems',
                'getBlockItems'
            ]),
            featured_mobile_items() {
                let featured_mobile = [];

                if(this.slideItems) {
                    this.slideItems.map((item) => {
                        featured_mobile.push(item);
                    })
                }

                if(this.blockItems) {
                    this.blockItems.map((item) => {
                        featured_mobile.push(item);
                    })
                }

                return featured_mobile;
            }
        },
        components: {
            PostListItemSmall,
            PostSmallBlock,
            PostBlockWrapper,
            PostBlockGroup,
            FeaturedPosts,
            PostListItem,
            Widget,
            Ad,
            GoogleAd,
        },
        methods: {
            getBanners() {
                this.$store.dispatch('getBanners', [
                    'home_featured_230h','home_category1_190','home_category2_190','home_popular_370'
                ]).then((response) => {
                    this.banners = response ? response : [];
                   this.home_featured_230h = this.banners.find(b => b.side === 'home_featured_230h');
                   this.home_category1_190 = this.banners.find(b => b.side === 'home_category1_190');
                   this.home_category2_190 = this.banners.find(b => b.side === 'home_category2_190');
                   this.home_popular_370 = this.banners.find(b => b.side === 'home_popular_370');
                });

                this.$store.dispatch('getGBanners', [
                    'ghome_featured_230h','ghome_category1_190','ghome_category2_190','ghome_popular_370'
                ]).then((response) => {
                    this.gbanners = response ? response : [];
                   this.ghome_featured_230h = this.gbanners.find(b => b.position === 'ghome_featured_230h');
                   this.ghome_category1_190 = this.gbanners.find(b => b.position === 'ghome_category1_190');
                   this.ghome_category2_190 = this.gbanners.find(b => b.position === 'ghome_category2_190');
                   this.ghome_popular_370 = this.gbanners.find(b => b.position === 'ghome_popular_370');
                });
            }
        },
        mounted() {
            this.getBanners();
        },
        watch: {
            getFeaturedPosts: function(newVal, oldVal) {
                this.featuredPosts = newVal;
            },
            getMostUsedKeywordsPosts: function(newVal) {
                this.mostUsedKeywordsPosts = newVal;
            },
            getRecentPosts: function(newVal) {
                this.recentPosts = newVal;
            },
            getMostPopularPosts: function(newVal, oldVal) {
                this.mostPopularPosts = newVal;
            },
            getMostPopularPostCover: function(newVal, oldVal) {
                this.mostPopularPostCover = newVal;
            },
            getTechItemsCover: function(newVal) {
                this.techItemsCover = newVal;
            },
            getTechItems: function(newVal) {
                this.techItems = newVal;
            },
            getSlideItems: function(newVal) {
                this.slideItems = newVal;
            },
            getBlockItems: function(newVal) {
                this.blockItems = newVal;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list-post {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .hblock {
        padding: 0px 35px 20px 33px;
    }

    .ml-11 {
        margin-left: 11px;
    }

    .ml-0 {
        margin-left: 0px;
    }

    .ml-m6 {
        margin-left: -6px;
    }

    .mt-40 {
        margin-top: 40px;
    }

    .w-350 {
        width: 350px;
    }
    .pad-right-block {
        padding: 0px 15px 0px 15px;
    }

    /* mobile */
    @media (max-width: 576px) {
        #home-page {

            widget .most-popular {
                margin-left: 13px !important;
                margin-right: 15px !important;
            }

            .most-popular, .w-fan-page {
                margin-left: 0px !important;
                margin-right: 0px !important;
            }

            .most-popular-cont {
                padding: 0px;
            }

            .home-block-g {

                post-block-group {

                    .w-100 {
                        width: auto !important;
                    }

                    .block-title {
                        margin-left: 0px !important;
                    }
                }
            }

            .list-post {
                padding-left: 7px;
            }
        }

        .hblock {
            padding: 0px 15px 15px 15px;
        }
    }

</style>
